<template>
  <div class="mt-[16px] px-[8px] mx-auto flex-y-center justify-between">
    <div class="flex-y-center text-font-1 flex-1 gap-[2px]">
      <span class="text-[12px] text-font-40 mr-[10px]">{{ $t('da-jia-du-zai-sou') }}</span>
      <div class="flex-y-center flex-1 gap-[15px] h-[13px] flex-wrap overflow-hidden">
        <a
          v-for="item in popularList?.data"
          :key="item"
          class="text-font-1 text-[12px]"
          @click="chooseKey(item)"
        >
          {{ item }}
        </a>
      </div>
    </div>
    <a
      class="flex-y-center cursor-pointer gap-[4px] text-font-40 text-[12px]"
      @click="popularRefresh"
    >
      <iconpark-icon name="arrow-refresh" size="16" />{{ $t('huan-yi-huan') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { getSiteHotWord } from '~/api/module/search';
import { SEARCH_HOT_WORD, SEARCH_RECORD_UNIQUE } from '~/constants/index';
import { ClickType } from './constant';

const emits = defineEmits(['select']);
const props = defineProps<{
  area: SEARCH_RECORD_UNIQUE;
  source?: SOURCE;
}>();

// 对应埋点source
const trackSource = {
  [SEARCH_RECORD_UNIQUE.TEMPLATE]: SOURCE.TEMPLATE_CENTER,
  [SEARCH_RECORD_UNIQUE.CHARACTER]: SOURCE.CHARACTER,
  [SEARCH_RECORD_UNIQUE.SITE]: SOURCE.SITE_SEARCH,
  [SEARCH_RECORD_UNIQUE.HELP_CENTER]: SOURCE.HELP_CENTER,
};

const { data: popularList, refresh } = useAsyncData(() =>
  getSiteHotWord(
    props.area === SEARCH_RECORD_UNIQUE.SITE ? SEARCH_HOT_WORD.SITE : SEARCH_HOT_WORD.HELP,
    8,
  ),
);

const popularRefresh = () => {
  trackEvent(TRACK_EVENT.CLICK_SITE_SEARCH, {
    source: props.source || trackSource[props.area],
    click_type: ClickType['换一换'],
  });
  refresh();
};

const chooseKey = (key: string) => {
  trackEvent(TRACK_EVENT.CLICK_SITE_SEARCH, {
    source: props.source || trackSource[props.area],
    keywords: key,
    click_type: ClickType['热搜词'],
  });
  emits('select', key);
};
</script>
